import { EventKeyMap } from './eventMapping';
import { Tracker } from './tracker';

export * from './eventMapping';
export * from './tracker';

export function subscriptionSuccessTrack(params: object) {
  return new Promise(resolve => {
    Tracker.track(EventKeyMap.purchase_success, {
      ...params,
      event_callback: () => {
        resolve(true);
      },
    });
    setTimeout(() => {
      resolve(true);
    }, 2000);
  });
}

// usage
// subscriptionSuccessTrack({
//   plan: 'pro',
//   amount: 100,
//   currency: 'USD',
// }).then(() => {
//   console.log('subscription success');
// });